<template>
  <div class="sm-facets">
    <div class="sm-facets-container">

        <FacetCategories></FacetCategories>

        <FacetSlider></FacetSlider>

        <Facets @filterchanged="onFilterChanged"></Facets>

   </div>
 </div>
</template>

<script>
import FacetCategories from './facet-categories.vue';
import FacetSlider from './facet-slider.vue';
import Facets from './facets.vue';
import {mapGetters, mapActions} from "vuex";

export default {
 name: "facets-container",
 components: {
   FacetCategories,
   FacetSlider,
   Facets
 },
  methods: {
    onFilterChanged: function () {
      if(this.$refs.InfiniteLoading){
        // сброс состояния компоненты infinite-loading
        this.$refs.InfiniteLoading.stateChanger.reset();
      }
    },
  }
}
</script>